import { useEffect } from 'react';

function useScrollToTop(pathname: string) {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, [pathname]);
}

export { useScrollToTop };
